import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { GalleryComponent } from './gallery.component';
import { FileChooserPresentationModule } from '../FileChooserPresentation/file-chooser-presentation.module';
import { SearchCriteriaModule } from '../project/searchFilter/search-criteria.module';
import { GalleryRoutingModule } from './gallery-routing.module';
import {InformationSideBarModule} from '../informationSideBar/information-side-bar.module';
import {PaginationModule} from '../project/pagination/pagination.module';
import {PaginationGadgetModule} from '../paginationGadget/pagination-gadget.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSelectModule,
    FileChooserPresentationModule,
    SearchCriteriaModule,
    GalleryRoutingModule,
    InformationSideBarModule,
    PaginationModule,
    PaginationGadgetModule
  ],
  declarations: [GalleryComponent],
  providers: [],
  exports: [GalleryComponent]
})

export class GalleryModule {

}
